import Axios from "../../../_services/caller.service";
import React, { useContext, useState } from "react";
import styles from "./ChangePassword.module.scss";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { handleValidation } from "../../../utils/formValidation";
import InputPassword from "../../UiComponents/forms/InputPassword";
import RulesPassword from "../../UiComponents/forms/RulesPassword";
import Loader from "../../UiComponents/loader/Loader";
import NavContext from "../../../context/NavContext";

const ChangePassword = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [oldPassword, setOldPassword] = useState("");

  const { ownerProfile, ownerId } = useContext(NavContext);

  const [errorValidation, setErrorValidation] = useState(null);
  const [loading, setLoading] = useState(false);

  const submitChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await Axios.put("/changePassword", {
        data: {
          currentPassword: oldPassword,
          password,
          password2,
        },
      });

      setLoading(false);

      if (res.data?.error) {
        toast.error(res.data.message || t("common.error_password_change"));
        return;
      }

      toast.success(res.data.message || t("common.password_changed"));

      setOldPassword("");
      setPassword("");
      setPassword2("");
      setErrorValidation(null);
    } catch (err) {
      setLoading(false);
      toast.error(t("common.error_occurred"));
      console.log(err);
    }
  };

  return (
    <form onSubmit={submitChangePassword} className={styles.form}>
      <InputPassword
        onChange={(e) => setOldPassword(e.target.value.trim())}
        placeholder={t("common.old_password")}
        value={oldPassword}
      />
      <InputPassword
        onChange={(e) => setPassword(e.target.value.trim())}
        placeholder={t("common.new_password")}
        onKeyUp={(e) => setErrorValidation(handleValidation(e))}
        value={password}
      />
      <InputPassword
        onChange={(e) => setPassword2(e.target.value.trim())}
        placeholder={t("common.confirm_new_password")}
        value={password2}
      />

      {errorValidation !== "" && errorValidation !== null && (
        <span className={styles.msgError}>{errorValidation}</span>
      )}
      {errorValidation === "" && (
        <span className={styles.msgSuccess}>{t("validation.password_valid")}</span>
      )}

      <button type="submit" className={styles.submitBtn}>
        {t("account.change_password_button")}
      </button>

      {loading && <Loader />}

      <RulesPassword />
    </form>
  );
};

export default ChangePassword;